// Adapted from case-desk src/main.tsx, 2026-08-03; P8 adds the User Timing app-start mark and the
// document language.
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './app/App';
import { i18n, initialLanguageReady } from './i18n/i18n';
import { markAppStart } from './lib/performance';

markAppStart();

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element #root was not found.');
}

// Language bundles load per language (see i18n.ts), so the first render waits until the detected
// language is registered. For the resident fallback `de-DE` this settles in a microtask.
void initialLanguageReady.then(() => {
  document.documentElement.lang = i18n.language;

  createRoot(rootElement).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
});
